import '@/styles/index.scss';
import 'floating-vue/dist/style.css';
import 'promise-polyfill/src/polyfill.js';
import '@/global/axios.js';
import axios from 'axios';
import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import SbsUiKitPlugin from 'sbs-ui-kit';
import * as Sentry from '@sentry/vue';
import { ToastDefaultOptions, Toast } from '@/global/toasts.js';
import router from '@/router/index.js';
import store from '@/store/index.js';
import { ClientErrorCodes } from '@/utils/httpStatusCodes.js';
import App from '@/App.vue';

const app = createApp(App);

const IGNORED_ERROR_STATUSES = [ClientErrorCodes.UNAUTHORIZED, ClientErrorCodes.FORBIDDEN, ClientErrorCodes.AUTHENTICATION_TIMEOUT];

if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_ENV,
        enabled: process.env.VUE_APP_SENTRY_ENABLED === 'true',
        integrations: [
            new Sentry.BrowserTracing({
                tracePropagationTargets: [process.env.VUE_APP_CLIENT_DOMAIN],
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay(),
        ],
        beforeSend: (event, hint) => {
            const error = hint?.originalException;
            const isAxiosError = axios.isAxiosError(error);
            const isIgnoredStatusError = error?.response?.status && IGNORED_ERROR_STATUSES.includes(error?.response.status);
            const isUserAuthError = typeof event?.message === 'string' && event?.message?.includes('[user] error while get data from api'); // error from user store

            if ((isAxiosError && isIgnoredStatusError) || isUserAuthError) return null;

            return event;
        },
        tracesSampleRate: 1, // Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0,
        trackComponents: true,
    });
}

app.use(store);
app.use(router);
app.use(SbsUiKitPlugin);
app.use(FloatingVue, {
    themes: {
        sbs: {
            $extend: 'dropdown',
            $resetCss: true,
        },
    },
});
app.use(Toast, ToastDefaultOptions);

app.mount('#app');
